import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import MainLayout from '@/layouts/MainLayout';
import { authUtils } from '@/utils/auth';

export default function NotFoundPage() {
  const isLoggedIn = authUtils.isAuthenticated();

  const content = (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-muted-foreground mb-2">404</h1>
        <h2 className="text-xl font-bold tracking-tight text-foreground mb-2">
          Page not found
        </h2>
        <p className="text-muted-foreground mb-8 max-w-md">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => window.history.back()} aria-label="Go back to previous page">
            <ArrowLeft className="w-4 h-4 mr-2" aria-hidden="true" />
            Go Back
          </Button>
          <Link to={isLoggedIn ? '/dashboard' : '/login'}>
            <Button aria-label="Go to home page">
              <Home className="w-4 h-4 mr-2" aria-hidden="true" />
              {isLoggedIn ? 'Dashboard' : 'Login'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );

  // If logged in, render inside the app shell so sidebar/header stay visible
  if (isLoggedIn) {
    return <MainLayout>{content}</MainLayout>;
  }

  // If not logged in, render a standalone page
  return (
    <div className="min-h-screen flex items-center justify-center bg-muted">
      {content}
    </div>
  );
}
